import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { ApprovalRequestEvent } from "../../../types/ai-event";

interface ApprovalPromptProps {
  event: ApprovalRequestEvent;
  onApprove: (id: string) => void;
  onDeny: (id: string) => void;
}

export const ApprovalPrompt: React.FC<ApprovalPromptProps> = ({
  event,
  onApprove,
  onDeny,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.warning.main}`,
        borderRadius: 1,
        p: 1.5,
        my: 0.5,
        backgroundColor: theme.palette.warning.dark + "11",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
        Approval needed: {event.toolName}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontFamily: "monospace",
          fontSize: "0.8rem",
          mb: 1,
          whiteSpace: "pre-wrap",
        }}
      >
        {JSON.stringify(event.input, null, 2)}
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          size="small"
          variant="contained"
          color="success"
          onClick={() => onApprove(event.id)}
        >
          Approve
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => onDeny(event.id)}
        >
          Deny
        </Button>
      </Box>
    </Box>
  );
};
